export default (dis, store, client) => {
    function load(id) {
      return client.get(`/api/campaigns/${id}`)
    }

    return {
      load
    }
}